import React, { Component } from "react";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import Typography from "@material-ui/core/Typography";

import withStyles from "@material-ui/styles/withStyles";

import shotService from "../../../services/shotService";
import ReviewShotShootStep from "./ReviewShotShootStep";
//components
import SelectShotsStep from "./SelectShotsStep";
//containers
import AdminWrapper from "../../../containers/AdminWrapper";
import ContentWrapper from "../../../containers/ContentWrapper";
import update from "immutability-helper";

const styles = theme => ({
  button: {
    marginRight: theme.spacing.unit
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit
  }
});

class ViewShotShootSteppers extends Component {
  state = {
    activeStep: 0,
    skipped: new Set(),
    shots: [],
    fetching: true,
    failed: false,
    selectedShots: [],
    reviewShots: [],
    scenes: [],
    selectedAll: false,
    submitting: false,
    selectedFilter: "",
    packageDetails: {}
  };

  componentDidMount() {
    this.getShots();
  }

  // handleSelectedShot = index => {
  //   let { data } = this.state;
  //   data[index].selected = !data[index].selected;
  //   this.setState({
  //     data
  //   });
  // };

  handleSelectedShot = id => {
    let { selectedShots } = this.state;
    console.log(id);
    if (selectedShots.includes(id)) {
      let index = selectedShots.indexOf(id);
      console.log(selectedShots);
      let newOutput = update({ selectedShots }, { selectedShots: { $splice: [[index, 1]] } });
      selectedShots = newOutput.selectedShots;
    } else {
      selectedShots = selectedShots.concat(id);
    }
    this.setState({ selectedShots });
  };

  // onSelectedAll = () => {
  //   let { data } = this.state;
  //   if (this.state.selectedAll) {
  //     data = data
  //       .filter(item => item.scene.toUpperCase().includes(this.state.selectedFilter.toUpperCase()))
  //       .map(shot => {
  //         shot.selected = false;
  //         return shot;
  //       });
  //   } else {
  //     data = data
  //       .filter(item => item.scene.toUpperCase().includes(this.state.selectedFilter.toUpperCase()))
  //       .map(shot => {
  //         shot.selected = true;
  //         return shot;
  //       });
  //   }
  //   console.log("main", data);
  //   this.setState({
  //     selectedAll: !this.state.selectedAll,
  //     data
  //   });
  // };

  onSelectedAll = (property, sourceProperty, filterProperty) => {
    // console.log(property, sourceProperty, filterProperty);
    let selectedSource = this.state[property];
    let source = this.state[sourceProperty];
    // console.log(selectedSource, source, filterProperty);
    if (source.length !== selectedSource.length) {
      if (this.state.selectedFilter) {
        source = source.filter(item => item[filterProperty] == this.state.selectedFilter);
      }
      source = source.map(item => {
        let { id, suffix } = item;
        return `${id}:${suffix}`;
      });
    } else {
      source = [];
    }
    // console.log(selectedSource, source, filterProperty);
    this.setState({ [property]: source });
  };

  handleFilter = (e, property, sourceProperty, filterProperty) => {
    if (e.target.value) {
      let selectedSource = this.state[property];
      let source = this.state[sourceProperty];
      console.log(source);

      source = source.filter(item => item[filterProperty] == e.target.value && selectedSource.includes(`${item.id}:${item.suffix}`));
      source = source.map(item => {
        let { id, suffix } = item;
        return `${id}:${suffix}`;
      });

      this.setState({ selectedFilter: e.target.value, [property]: source });
    } else this.setState({ selectedFilter: e.target.value });
  };

  getShots = async () => {
    try {
      if (!this.state.fetching) this.setState({ fetching: true });
      let shotPackage = await shotService.getOnePackage(this.props.match.params.id);

      let { shots, ...packageDetails } = shotPackage.data;
      let scenes = shots
        .map(i => i.scene)
        .filter((item, i, arr) => arr.indexOf(item) === i)
        .sort();

      this.setState({ shots, packageDetails, scenes, fetching: false, failed: false });
    } catch (err) {
      console.log(err);
      this.setState({ data: [], fetching: false, failed: true });
    }
  };

  submitShots = async () => {
    try {
      console.log(this.state.selectedShots);
      this.setState({ submitting: true });
      // this.state.selectedShots.map(shot => {
      //   const { id } = shot;
      //   const withsufix = `${id}:${shot.suffix}`;
      //   dataShot.push(withsufix);
      //   // if (this.props.router.search.type === "photo") {
      //   //   const { angle, description, framing, id, location, scene, type, priority } = shot;
      //   //   return { angle, description, framing, id, location, scene, type, priority };
      //   // } else {
      //   //   const { angle, camera, description, framing, id, location, scene, type, priority,video_url } = shot;
      //   //   return {
      //   //     angle,
      //   //     camera,
      //   //     description,
      //   //     framing,
      //   //     id,
      //   //     location,
      //   //     scene,
      //   //     type,
      //   //     priority,
      //   //     video_url
      //   //   };
      //   // }
      // });
      let result = await shotService.removeShotsFromPackage(this.props.match.params.id, {
        shots: this.state.selectedShots
      });
      console.log("result", result);

      this.setState({ submitting: false });
      let { id } = this.props.match.params;
      this.props.history.replace(`/packages/view/${id}`);
    } catch (err) {
      this.setState({ submitting: false });
    }
  };

  handleNext = () => {
    const { activeStep } = this.state;
    let { skipped } = this.state;
    if (this.isStepSkipped(activeStep)) {
      skipped = new Set(skipped.values());
      skipped.delete(activeStep);
    }
    this.setState({
      activeStep: activeStep + 1,
      skipped
    });
  };

  handleBack = () => {
    this.setState({
      activeStep: this.state.activeStep - 1
    });
  };

  handleSkip = () => {
    const { activeStep } = this.state;
    if (activeStep > 1) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    this.setState(state => {
      const skipped = new Set(state.skipped.values());
      skipped.add(activeStep);
      return {
        activeStep: state.activeStep + 1,
        skipped
      };
    });
  };

  isStepSkipped(step) {
    return this.state.skipped.has(step);
  }

  getSteps() {
    return ["Select Shots for the shoot", "Review shots"];
  }

  proceedToReview = () => {
    let { selectedShots } = this.state;
    let reviewShots = this.state.shots.filter(i => selectedShots.includes(`${i.id}:${i.suffix}`));
    console.log(reviewShots);
    this.setState({
      reviewShots
    });
    this.handleNext();
  };

  getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <SelectShotsStep
            shots={this.state.shots}
            fetching={this.state.fetching}
            failed={this.state.failed}
            getShots={this.getShots}
            handleSelectedShot={this.handleSelectedShot}
            proceedToReview={this.proceedToReview}
            goBackStep={this.handleBack}
            selectedAll={this.state.selectedAll}
            onSelectedAll={this.onSelectedAll}
            type={this.state.packageDetails.type}
            handleFilter={this.handleFilter}
            selectedShots={this.state.selectedShots}
            selectedFilter={this.state.selectedFilter}
            scenes={this.state.scenes}
          />
        );
      case 1:
        return (
          <ReviewShotShootStep
            goBackStep={this.handleBack}
            shots={this.state.reviewShots}
            submitShots={this.submitShots}
            type={this.state.packageDetails.type}
            submitting={this.state.submitting}
          />
        );
      default:
        return "Unknown step";
    }
  }

  render() {
    const { classes } = this.props;
    const steps = this.getSteps();
    const { activeStep } = this.state;

    if (this.state.fetching) {
      return (
        <AdminWrapper {...this.props}>
          <ContentWrapper hasHeader title="Edit Shots">
            <div style={{ padding: "30px 0", textAlign: "center" }}>
              <CircularProgress color="primary" />
            </div>
          </ContentWrapper>
        </AdminWrapper>
      );
    } else
      return (
        <AdminWrapper {...this.props}>
          <ContentWrapper hasHeader title="Edit Shots">
            {this.state.shots.length > 0 ? (
              <>
                <Stepper activeStep={activeStep} alternativeLabel>
                  {steps.map((label, index) => {
                    const props = {};
                    if (this.isStepSkipped(index)) {
                      props.completed = false;
                    }
                    return (
                      <Step key={label} {...props}>
                        <StepLabel>{label}</StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
                <div>
                  {activeStep === steps.length ? (
                    <div>
                      <Typography className={classes.instructions}>All steps completed - you&apos;re finished</Typography>
                    </div>
                  ) : (
                    this.getStepContent(activeStep)
                  )}
                </div>
              </>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "30px 0",
                  flexDirection: "column"
                }}
              >
                <Typography variant="display3" style={{ margin: "20px 0" }}>
                  {this.state.shots.length === 0 ? "No shots selected." : "You have selected all shots"}
                </Typography>
                <Button variant="contained" color="primary" onClick={() => this.props.history.goBack()}>
                  Go back
                </Button>
              </div>
            )}
          </ContentWrapper>
        </AdminWrapper>
      );
  }
}

export default withStyles(styles)(ViewShotShootSteppers);
